import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

export async function fetchRelatedShipments(body: {
  orderId: string;
  paging?: {
    page?: number;
    size?: number;
  };
}) {
  const data = await axios.post(`${BASE_URL}/orders/relatedShipments`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data?.data;
}
